import { ILatestSavedApplication, SavedApplicationsApiClient } from 'api/SavedApplicationsApiClient'
import { useApiClient } from '@hooks'
import { useEffect, useState } from 'react'

export default function useLatestVersionOfApplication(
    referenceId: string | undefined,
    dealerId: number | undefined) {
    const savedApplicationsApiClient = useApiClient(x => new SavedApplicationsApiClient(x))
    const [latestSavedApplication, setApplication] = useState<ILatestSavedApplication>()
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (referenceId === undefined) {
            return
        }

        setLoading(true)
        savedApplicationsApiClient.getLatestByReferenceId(dealerId!, referenceId)
            .then(x => setApplication(x!))
            .finally(() => setLoading(false))
    }, [])

    return [latestSavedApplication, loading] as [ILatestSavedApplication | undefined, boolean]
}